import React from 'react'
import {InputDefault} from '../../components/ui'
import {useFormik} from 'formik'

interface Props {
  handleChange?: (e: any) => void
  id?: string
  initLoad?: any
  loadings: boolean
}

const FormConfig: React.FC<Props> = ({handleChange, initLoad, loadings}) => {
  const initValue = {
    global_percentage: '',
    conversion_currency: '',
    conversion_point: '',
  }

  const formik = useFormik({
    initialValues: initLoad,
    onSubmit: (values, {resetForm}) => {
      handleChange!(values)
    },
    enableReinitialize: true,
  })
  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Conversion Point</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <InputDefault
                type='number'
                id='conversion_point'
                name='conversion_point'
                onChange={formik.handleChange}
                value={formik.values.conversion_point}
                readOnly
              />
              <span className='fw-bolder fs-6 me-6'>Point</span>
              <InputDefault
                type='number'
                id='conversion_currency'
                name='conversion_currency'
                onChange={formik.handleChange}
                value={formik.values.conversion_currency}
              />
              <span className='fw-bolder fs-6 me-6'>IDR</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'> Masa Berlaku Point </label>
            <div className='col-lg-8 d-flex align-items-center'>
              <InputDefault
                type='number'
                id='global_percentage'
                name='global_percentage'
                onChange={formik.handleChange}
                value={formik.values.global_percentage}
              />
              <span className='fw-bolder fs-6 me-6'>hari</span>
            </div>
          </div>

          <div className='d-flex justify-content-end py-4 '>
            {!loadings ? (
              <button className='btn btn-primary' data-bs-target='#add-edit-member' type='submit'>
                Submit
              </button>
            ) : (
              <button className='btn btn-primary' data-kt-indicator='on' type='button'>
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  )
}

export default FormConfig
